import { SettingOutlined, MoreOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Space, Tooltip, Dropdown, Typography } from 'antd';

import {
  U_ACTION,
  U_BRANCH,
  U_CITY,
  U_KEY,
  U_NAME,
  U_OWNER,
} from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NOrganization } from '@app/types/Organization';

import type { SelectOrganizationUserModalApi } from '@pages/Organizations/OrganizationsList/components/SelectUserModal';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Link } = Typography;

export const adaptDataToTable = ({
  data,
  hasUserRightToSecretLinks,
  handleNavigateToSettings,
  handleNavigateToUsers,
  openUserSelectModal,
}: {
  data: NOrganization.OrganizationListItem[];
  hasUserRightToSecretLinks: boolean;
  handleNavigateToSettings: (id: number) => void;
  handleNavigateToUsers: (id: number) => void;
  openUserSelectModal?: SelectOrganizationUserModalApi['open'];
}) => {
  return data.map((organization) => {
    const {
      Id,
      Database,
      Name,
      Inn,
      Kpp,
      City,
      Country,
      BranchName,
      BranchAddress,
      OwnerFullName,
      OwnerEmail,
      OwnerPhone,
    } = organization;

    const menu = {
      items: [
        {
          key: '1',
          label: generateSpanWithDataTestId('Пользователи', 'users-menu'),
          onClick: () => handleNavigateToUsers(Id),
        },
        ...(hasUserRightToSecretLinks
          ? [
              {
                key: '2',
                label: generateSpanWithDataTestId('Вход', 'login-menu'),
                onClick: () =>
                  openUserSelectModal &&
                  openUserSelectModal({
                    databaseId: Database,
                    organizationId: Id,
                  }),
              },
            ]
          : []),
      ],
    };

    return {
      [U_KEY]: String(Id),
      [U_NAME]: (
        <div>
          <div data-testid="organization-name">{Name}</div>
          {Inn && <div className="secondary-text">{`ИНН: ${Inn}`}</div>}
          {Kpp && <div className="secondary-text">{`КПП: ${Kpp}`}</div>}
        </div>
      ),
      [U_CITY]: (
        <div>
          <div data-testid="organization-city">{City}</div>
          <div className="secondary-text" data-testid="organization-country">
            {Country}
          </div>
        </div>
      ),
      [U_BRANCH]: (
        <div>
          <div data-testid="branch-name">{BranchName}</div>
          <address
            className="secondary-text"
            style={{ fontStyle: 'normal' }}
            data-testid="branch-address"
          >
            {BranchAddress}
          </address>
        </div>
      ),
      [U_OWNER]: (
        <div>
          <div data-testid="owner-name">{OwnerFullName}</div>
          <div>
            <Link href={`tel:${OwnerPhone}`} data-testid="organization-phone">
              <FontAwesomeIcon
                icon={'fa-solid fa-phone' as IconProp}
                size="sm"
                style={{ marginRight: 8 }}
              />
              {OwnerPhone}
            </Link>
          </div>
          <div>
            <Link
              href={`mailto:${OwnerEmail}`}
              data-testid="organization-email"
            >
              <FontAwesomeIcon
                icon={'fa-solid fa-envelope' as IconProp}
                size="sm"
                style={{ marginRight: 8 }}
              />
              {OwnerEmail}
            </Link>
          </div>
        </div>
      ),
      [U_ACTION]: (
        <Space>
          <Tooltip title="Настройки">
            <Button
              icon={<SettingOutlined />}
              onClick={() => handleNavigateToSettings(Id)}
              data-testid="organization-settings"
            />
          </Tooltip>
          <Dropdown menu={menu} trigger={['click']}>
            <Button icon={<MoreOutlined />} data-testid="organization-menu" />
          </Dropdown>
        </Space>
      ),
    };
  });
};
